// extracted by mini-css-extract-plugin
export default {"header_item":"header_item__7RJV5","standard_brand_logo":"standard_brand_logo__AW+Nq","wide_brand_logo":"wide_brand_logo__kNv7t"};